module.exports = __webpack_public_path__ + "img/IMG_1156_L_WoodMatted.9558b1c4.jpg";